import { useState, useEffect } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import {
  APIEditVisLandmarks,
  APIEditLandmarksWithFiles,
} from "../../helper/APIFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faArrowUp,
  faArrowDown,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import "./LandmarkModal.css";
import DeleteModal from "./Delete";

const AUDIOFILESIZEMB = 4;

const SubModal = (props) => {
  const lm = props.landmark || {};
  const [title, setTitle] = useState(lm.title || "");
  const [desc, setDesc] = useState(lm.description || "");
  const [markerPos, setMarkerPos] = useState(lm.position || null);
  const [cameraPos, setCameraPos] = useState(lm.cameraPos || null);
  const [duration, setDuration] = useState(lm.duration || 10);
  const [upVector, setUpVector] = useState(lm.upVector || [0, 1, 0]);
  const [durationRaw, setDurationRaw] = useState(
    (lm.duration || 10).toString()
  );
  const [durationError, setDurationError] = useState(null);
  const [audioFile, setAudioFile] = useState(null);
  const [removeAudio, setRemoveAudio] = useState(false);
  const [touched, setTouched] = useState(false);
  const onMsgListener = (event) => {
    const data = event.data;
    if (data.description == "NewLandmarkPosition") {
      if (!data.result) {
        props.resetLandmarks();
        props.showFcn();
      } else {
        let temp = {
          title: title,
          description: desc,
          position: Array.from(data.result.position),
        };
        if (!props.noCameraPos) {
          temp.duration = duration;
          temp.audio = data.result.audio;
          temp.audioDuration = data.result.audioDuration;
          temp.cameraPos = Array.from(data.result.cameraPos);
          temp.upVector = Array.from(data.result.upVector) || [0, 1, 0];
        }
        if (data.result.component) {
          temp.component = data.result.component;
        }
        props.onFinalize(props.index, temp);
      }
      return;
    }
  };
  useEffect(() => {
    window.addEventListener("message", onMsgListener);
    return () => {
      window.removeEventListener("message", onMsgListener);
    };
  }, [title, desc]);
  useEffect(() => {
    if (/^\s*\d*(\.\d*)?\s*$/.test(durationRaw)) {
      const duration = parseFloat(durationRaw);
      if (!duration) {
        setDurationError("Duration must not be zero");
        return;
      }
      setDuration(duration);
      setDurationError(null);
      return;
    }
    setDurationError("Invalid Format");
  }, [durationRaw]);
  return (
    <Modal show={props.show} onHide={props.onHide} dialogClassName="landmark-submodal">
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>{props.index === -1 ? "New Landmark" : "Edit Landmark"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId={"landmark-title"} className="mb-3">
          <Form.Label>Title</Form.Label>
          <Form.Control
            type="text"
            value={title}
            placeholder="Landmark Title"
            onChange={(event) => {
              setTitle(event.target.value);
              setTouched(true);
            }}
            dir="auto"
            isInvalid={!title || !title.match(/\S/)}
          />
          <Form.Control.Feedback type="invalid">
            Title cannot be empty
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId={"landmark-description"} className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            value={desc}
            dir="auto"
            placeholder="Optional Description for Landmark"
            onChange={(event) => {
              setDesc(event.target.value);
              setTouched(true);
            }}
          />
        </Form.Group>
        {props.canAudio ? (
          <Form.Group controlId={"landmark-duration"} className="mb-3">
            <Form.Label>Tour Duration (seconds)</Form.Label>
            <Form.Control
              value={durationRaw}
              onChange={(event) => {
                setDurationRaw(event.target.value);
                setTouched(true);
              }}
              isInvalid={durationError}
            />
            <Form.Control.Feedback type="invalid">
              {durationError}
            </Form.Control.Feedback>
          </Form.Group>
        ) : null}
        <Form.Group controlId={"landmark-pos"} className="mb-4">
          <Form.Label>
            Landmark & Camera Positions
            <span
              className={`landmark-position-status ${
                markerPos && (cameraPos || props.noCameraPos) ? "valid" : "invalid"
              }`}
            >
              {markerPos && (cameraPos || props.noCameraPos) ? "✓ Valid" : "✗ Invalid"}
            </span>
          </Form.Label>
          <Button
            variant="secondary"
            className="w-100 btn-update"
            onClick={() => {
              props.hideFcn();
              document.getElementById(props.viewerId).contentWindow.postMessage(
                {
                  description: "CreateNewLandmark",
                  result: props.index >= 0 ? props.index + 1 : -1,
                },
                "https://vis.snorkle.io"
              );
            }}
            disabled={!title || !title.match(/\S/)}
          >
            Update Positions
          </Button>
        </Form.Group>
        {props.canAudio ? (
          <>
            {lm.audio ? (
              <Form.Group className="mb-3">
                <Form.Check
                  label="Remove Current Audio Track"
                  checked={removeAudio}
                  onChange={(e) => {
                    setRemoveAudio(e.target.checked);
                    setTouched(true);
                  }}
                />
              </Form.Group>
            ) : null}
            {!lm.audio || removeAudio ? (
              <Form.Group className="mb-3">
                <Form.Label className="col-auto">New Audio Track</Form.Label>
                <Form.Control
                  type="file"
                  onChange={(event) => {
                    setAudioFile(
                      event.target.files.length ? event.target.files[0] : null
                    );
                    setTouched(true);
                  }}
                  isInvalid={
                    audioFile && audioFile.size > AUDIOFILESIZEMB * 1024 * 1024
                  }
                  accept="audio/mpeg"
                />
                <Form.Control.Feedback type="invalid">
                  Selected file is too large.
                </Form.Control.Feedback>
                <Form.Text>
                  Accepts a .mp3 file with a limit of {AUDIOFILESIZEMB}MB
                </Form.Text>
              </Form.Group>
            ) : null}
          </>
        ) : null}

        <Button
          onClick={() => {
            let t = {
              title: title,
              description: desc,
              position: markerPos,
            }
            if (!props.noCameraPos) {
              t.duration = duration;
              t.audioFile = audioFile;
              t.audio = removeAudio ? null : lm.audio;
              t.audioDuration = removeAudio ? null : lm.audioDuration;
              t.cameraPos = cameraPos;
              t.upVector = upVector;
            }
            props.onFinalize(props.index, t);
          }}
          disabled={
            !markerPos ||
            !(cameraPos || props.noCameraPos) ||
            !title ||
            !title.match(/\S/) ||
            !touched ||
            durationError ||
            (audioFile && audioFile.size > AUDIOFILESIZEMB * 1024 * 1024)
          }
        >
          Save Landmark Changes
        </Button>
      </Modal.Body>
    </Modal>
  );
};

const LandmarkModal = (props) => {
  const [statusTxt, setStatusTxt] = useState(null);
  const [isCallingAPI, setIsCallingAPI] = useState(false);
  const [currentLandmarks, setCurrentLandmarks] = useState([]);
  const [landmarksLoaded, setLandmarksLoaded] = useState(false);
  const [currentEditIndex, setCurrentEditIndex] = useState(null);
  const [showSubModal, setShowSubModal] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [showCNS, setShowCNS] = useState(false);
  const [landmarkInterval, setLandmarkInterval] = useState(null);
  const [noCameraPos, setNoCameraPos] = useState(false);
  const [nocacheUrlSuffix, _] = useState(`?now=${Date.now()}`);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const onMsgListener = (event) => {
    const data = event.data;
    if (data.description == "CurrentLandmarks") {
      setCurrentLandmarks(data.result);
      setNoCameraPos(data.noCameraPos || false);
      setLandmarksLoaded(true);
      clearTimeout(landmarkInterval);
      setLandmarkInterval(null);
      return;
    }
  };
  useEffect(() => {
    window.addEventListener("message", onMsgListener);
    return () => {
      window.removeEventListener("message", onMsgListener);
    };
  }, []);

  const viewerId = "landmark-viewer" + props.vis.id;
  useEffect(() => {
    if (props.show) {
      document.getElementById(viewerId).onload = () => {
        const pollForLandmarks = () => {
          const element = document.getElementById(viewerId);
          if (element) {
            element.contentWindow.postMessage(
              "FetchLandmarks",
              "https://vis.snorkle.io"
            );
            setLandmarkInterval(setTimeout(pollForLandmarks, 250));
          }
        };
        setLandmarkInterval(setTimeout(pollForLandmarks, 250));
      };
    }
  }, [props.show]);

  const updateLandmarks = (arr = null) => {
    if (isCallingAPI) {
      return;
    }
    setStatusTxt(null);
    const res = arr || currentLandmarks;
    document
      .getElementById(viewerId)
      .contentWindow.postMessage(
        { description: "UpdateLandmarks", result: res || [] },
        "https://vis.snorkle.io"
      );
    if (arr) {
      setIsDirty(true);
      setCurrentLandmarks(arr);
    }
  };

  const handleClose = () => {
    if (isDirty) {
      setShowCNS(true);
    } else {
      props.onHide();
    }
  };

  return (
    <>
      <Modal show={props.show} onHide={handleClose} centered dialogClassName="modal-xl landmark-modal">
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>Edit Landmarks</Modal.Title>
        </Modal.Header>
        <Modal.Body className={showCNS ? "d-none" : ""}>
          {statusTxt && (
            <div className={`landmark-status-message ${statusTxt.valid ? "success" : "error"}`}>
              {statusTxt.msg}
            </div>
          )}
          {currentEditIndex !== null ? (
            <SubModal
              show={showSubModal}
              landmark={
                currentEditIndex != -1 ? currentLandmarks[currentEditIndex] : {}
              }
              noCameraPos={noCameraPos}
              index={currentEditIndex}
              onHide={() => {
                updateLandmarks();
                setShowSubModal(false);
                setCurrentEditIndex(null);
              }}
              hideFcn={() => {
                setShowSubModal(false);
              }}
              showFcn={() => {
                setShowSubModal(true);
              }}
              onSave={() => { }}
              resetLandmarks={updateLandmarks}
              canAudio={props.vis.can_audio_landmark}
              viewerId={viewerId}
              onFinalize={(index, newLm) => {
                const arr = [...currentLandmarks];
                if (index == -1) {
                  arr.push(newLm);
                } else {
                  arr[index] = newLm;
                }
                updateLandmarks(arr);
                setShowSubModal(false);
                setCurrentEditIndex(null);
              }}
            />
          ) : null}
          <div
            style={{
              flexGrow: 1,
              position: "relative",
              overflow: "hidden",
              width: "100%",
              minWidth: "300px",
              height: "500px",
              display: "flex",
              flexDirection: "row",
              gap: "0.5rem",
            }}
          >
            <iframe
              src={props.vis.visualization_url + nocacheUrlSuffix}
              id={viewerId}
              className="border border-secondary rounded"
              style={{
                width: "75%",
                height: "100%",
              }}
            />
            <div
              className="landmarks-list-container"
              style={{
                width: "25%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <h5 className="landmarks-list-header">Landmarks</h5>
              <div className="landmarks-scroll-container">
                {currentLandmarks.map((t, ind) => {
                  return (
                    <div className="landmark-card" key={ind}>
                      <div
                        className="landmark-icon-btn edit-btn"
                        aria-label="edit"
                        role="button"
                        tabIndex="0"
                        title={`Edit Landmark "${t.title}"`}
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          setShowSubModal(true);
                          setCurrentEditIndex(ind);
                        }}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                            event.stopPropagation();
                            setShowSubModal(true);
                            setCurrentEditIndex(ind);
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faPencil} size="sm" />
                      </div>

                      <div className="landmark-card-content">
                        <div className="landmark-card-title" dir="auto">
                          <span className="landmark-card-number">{ind + 1}</span>
                          {t.title}
                        </div>
                      </div>

                      <div className="landmark-actions">
                        <div className="landmark-actions-row">
                          {ind !== 0 && (
                            <div
                              className="landmark-icon-btn move-btn"
                              aria-label="move up"
                              role="button"
                              tabIndex="0"
                              title="Move Up"
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                const arr = [...currentLandmarks];
                                [arr[ind - 1], arr[ind]] = [arr[ind], arr[ind - 1]];
                                updateLandmarks(arr);
                              }}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  const arr = [...currentLandmarks];
                                  [arr[ind - 1], arr[ind]] = [arr[ind], arr[ind - 1]];
                                  updateLandmarks(arr);
                                }
                              }}
                            >
                              <FontAwesomeIcon icon={faArrowUp} size="sm" />
                            </div>
                          )}
                          {ind !== currentLandmarks.length - 1 && (
                            <div
                              className="landmark-icon-btn move-btn"
                              aria-label="move down"
                              role="button"
                              tabIndex="0"
                              title="Move Down"
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                const arr = [...currentLandmarks];
                                [arr[ind + 1], arr[ind]] = [arr[ind], arr[ind + 1]];
                                updateLandmarks(arr);
                              }}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  const arr = [...currentLandmarks];
                                  [arr[ind + 1], arr[ind]] = [arr[ind], arr[ind + 1]];
                                  updateLandmarks(arr);
                                }
                              }}
                            >
                              <FontAwesomeIcon icon={faArrowDown} size="sm" />
                            </div>
                          )}
                        </div>
                        <div
                          className="landmark-icon-btn delete-btn"
                          aria-label="delete"
                          role="button"
                          tabIndex="0"
                          title={`Delete Landmark "${t.title}"`}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            setConfirmDelete(t);
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter") {
                              event.preventDefault();
                              event.stopPropagation();
                              setConfirmDelete(t);
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faTrashCan} size="sm" />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <Button
                className="new-landmark-btn"
                onClick={() => {
                  setCurrentEditIndex(-1);
                  setShowSubModal(true);
                }}
                disabled={!landmarksLoaded}
              >
                + New Landmark
              </Button>
            </div>
          </div>
          <Button
            onClick={() => {
              setIsCallingAPI(true);
              setStatusTxt(null);
              const APIFunc = currentLandmarks.some((l) => l.audioFile)
                ? APIEditLandmarksWithFiles
                : APIEditVisLandmarks;
              APIFunc(
                props.vis,
                currentLandmarks,
                (res) => {
                  setIsCallingAPI(false);
                  setStatusTxt({ valid: true, msg: "✓ Landmarks Updated Successfully!" });
                  setIsDirty(false);
                  if (props.onVisEdit) {
                    props.onVisEdit(res.visualization);
                  }
                },
                (err) => {
                  setIsCallingAPI(false);
                  setStatusTxt({ valid: false, msg: err.message || (err.toUpperCase ? err : "Internal Server Error") });
                },
                props.isOrg
              );
            }}
            className="mt-4 landmark-commit-btn"
            disabled={isCallingAPI || !isDirty}
          >
            {isCallingAPI ? (
              <>
                <Spinner
                  animation="border"
                  role="loading"
                  className="align-center"
                  size="sm"
                  style={{ marginRight: "0.5rem" }}
                />
                Saving...
              </>
            ) : (
              "Commit Changes"
            )}
          </Button>
        </Modal.Body>
      </Modal>

      {confirmDelete && <DeleteModal
        show={!!confirmDelete}
        vis={confirmDelete}
        onVisDelete={(deletedLandmark) => {
          updateLandmarks(currentLandmarks.filter((l) => l !== deletedLandmark));
          setConfirmDelete(null);
        }}
        onHide={() => {
          setConfirmDelete(null);
        }}
        isLandmark
      />}

      <Modal show={showCNS} onHide={() => setShowCNS(false)} centered>
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>Unsaved Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You have unsaved changes. Are you sure you want to exit?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCNS(false)}>
            Stay
          </Button>
          <Button variant="primary" onClick={() => {
            setShowCNS(false);
            props.onHide();
          }}>
            Exit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LandmarkModal;